import Http from './http';
import store from 'store';

class UserGroupsService {
    constructor() {
        this.groups = null;
    }

    resetCache() {
        this.colleagues = null;
        store.set('userGroups', false);
        this.getUserGroups();
    }

    getUserGroups() {
        return new Promise((resolve, reject) => {
            if (this.groups) resolve(this.groups);
            else {
                Http.get('/client-groups/').then(resp => {
                    this.groups = resp.data;
                    store.set('userGroups', this.groups);
                    resolve(resp.data);
                });
            }
        })
    }
}

export default new UserGroupsService();


// WEBPACK FOOTER //
// ./src/services/Cache/micro-services/userGroups.js